import {
  getCompanyPortalOrigin,
  getCurrentApiKey,
  getDashboardApiBaseUrl,
  getEventApiBaseUrl,
  getTicketSearchPath,
  getTicketSearchWithSessionsPath,
  getUserApiBaseUrl
} from '../config/session'

export const BASE = {
  api: {
    base_url: '',
    user_validate: '/user/validate',
    user_create: '/user',
    validate_register_number: '/multiclubes/user/validate',
    send_face: '/biometry',
    visitor_create: '/visitor',
    visitor_report: '/visitor/report',
    valid_mask: '/biometry/validate/mask',
    valid_glasses: '/biometry/validate/glasses',
    create_face: '/biometry/create',
    remove_background: '/biometry/removeBackground',
    access_create: '/access',
    access_edit: '/access',
    access_find: '/access',
    access_login: '/access/login',
    access_search: '/access/search',
    hik_get_status: '/hikvision/local/getDeviceInfo',
    access_approver: '/approvers',
    access_reports: '/access-control/report',
    access_report_entrance: '/access/status',
    access_report_allusers: '/access/allusers',
    log_create: '/logs',
    get_log_from_gate: '/access-control/today',
    hik_get_cards: '/hikvision/status/card',
    find_user_with_biometry: '/biometry/find/users',
    remove_biometry: '/biometry',
    api_key: '',
    token: ''
  },
  local_api: {
    base_url: '',
    user_validate: '/user/validate',
    user_create: '/user',
    validate_register_number: '/multiclubes/user/validate',
    send_face: '/biometry',
    visitor_create: '/visitor',
    visitor_report: '/visitor/report',
    valid_mask: '/biometry/validate/mask',
    valid_glasses: '/biometry/validate/glasses',
    create_face: '/biometry/create',
    remove_background: '/biometry/removeBackground',
    access_create: '/access',
    access_edit: '/access',
    access_find: '/access',
    access_login: '/access/login',
    access_search: '/access/search',
    hik_get_status: '/hikvision/local/getDeviceInfo',
    access_report_entrance: '/access/status',
    access_report_allusers: '/access/allusers',
    log_create: '/logs',
    find_user_with_biometry: '/biometry/find/users',
    remove_biometry: '/biometry',
    api_key: '',
    token: ''
  },
  api_user: {
    base_url: '',
    user_validate: '/user/validate',
    user_create: '/user',
    user_edit: '/user',
    validate_register_number: '/multiclubes/user/validate',
    send_face: '/biometry',
    visitor_create: '/visitor',
    visitor_find_by_document: '/visitor/findByDocument',
    valid_mask: '/biometry/validate/mask',
    valid_glasses: '/biometry/validate/glasses',
    create_face: '/biometry/create',
    remove_background: '/biometry/removeBackground',
    access_create: '/access/create',
    access_edit: '/access/edit',
    access_get: '/access',
    log_create: '/logs',
    hik_get_cards: '/hikvision/status/card',
    find_user_with_biometry: '/biometry/find/users',
    remove_biometry: '/biometry',
    api_key: '',
    token: ''
  },
  ticket_api: {
    base_url: '',
    user_validate: '/tickets/search',
    user_validate_withsessions: '/tickets/search/withsessions',
    getQrCode: '/tickets/getQrCode',
    generateLog: '/tickets/generate-log',
    generateAccess: '/access-control',
    gate_template_default: '/gates/besafe/gate/template/default'
  }
}

Object.defineProperties(BASE.api, {
  base_url: {
    get: () => getDashboardApiBaseUrl()
  },
  api_key: {
    get: () => getCurrentApiKey()
  },
  token: {
    get: () => getCurrentApiKey()
  }
})

Object.defineProperties(BASE.api_user, {
  base_url: {
    get: () => getUserApiBaseUrl()
  },
  api_key: {
    get: () => getCurrentApiKey()
  },
  token: {
    get: () => getCurrentApiKey()
  }
})

Object.defineProperties(BASE.ticket_api, {
  base_url: {
    get: () => getEventApiBaseUrl()
  },
  user_validate: {
    get: () => getTicketSearchPath()
  },
  user_validate_withsessions: {
    get: () => getTicketSearchWithSessionsPath()
  }
})

Object.defineProperties(BASE.local_api, {
  base_url: {
    get: () => getDashboardApiBaseUrl()
  },
  api_key: {
    get: () => getCurrentApiKey()
  },
  token: {
    get: () => getCurrentApiKey()
  }
})

export const PORTALS = {
  get companyOrigin() {
    return getCompanyPortalOrigin()
  },
  get eventsBaseUrl() {
    return getEventApiBaseUrl()
  }
}
